<form
  [formGroup]="formGroup"
  (ngSubmit)="submit()"
  autocomplete="off"
  class="entry-form"
>
  <box class="field-set">

    <app-loan-TransactionPeriodList
      class="col-sm-12 col-lg-12 col-md-12"
      label="Transaction Period"
      placeholder="Transaction Period"
      formControlName="transactionPeriod"
    ></app-loan-TransactionPeriodList>

    <ng-container *ngIf="_responsive.isMobile()">
      <ng-container *ngIf="state.ismonthOrDate == 'MONTH'">
      <div class="yearmonthbx">
      <div  class="year-set">
        <div class="col-sm-12 col-lg-12 col-md-12">
        <app-loan-yearlist
          label="Year"
          placeholder="Year"
          formControlName="year"
          ngModel

        ></app-loan-yearlist>
      </div></div>
      <div class="date-container">
        <div class="month-set" class="col-sm-12 col-lg-12 col-md-12">
          <app-loan-MonthFlagList
            label="Month"
            placeholder="Month"
            formControlName="month"
			      [changePublisher]="formChangePublisher$"
            [dependencyField]="['year']"
            ngModel

          ></app-loan-MonthFlagList>
        </div>
      
      </div>
    </div>  
    </ng-container>
    </ng-container>
    <ng-container *ngIf="!_responsive.isMobile()">
      <div class="date-container" *ngIf="state.ismonthOrDate == 'MONTH'">
      
        <div class="year-set" >
          <app-loan-yearlist class="col-sm-12 col-lg-12 col-md-12"
            label="Year"
            placeholder="Year"
            formControlName="year"
            ngModel

          ></app-loan-yearlist>
        </div>

        <div class="month-set">
          <app-loan-MonthFlagList  class="col-sm-12 col-lg-12 col-md-12"
            label="Month"
            placeholder="Month"
            formControlName="month"
            ngModel
            [changePublisher]="formChangePublisher$"
            [dependencyField]="['year']"
          ></app-loan-MonthFlagList>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="_responsive.isMobile()">
      <div class="select-date" *ngIf="state.ismonthOrDate == 'DATE'">
        <div class="from-set">
          <app-request-date-control
            class="col-sm-12 col-lg-6 col-md-12"
            label="From"
            placeholder="From"
            formControlName="from"
            [minDate]="state.fromMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
        <div class="to-set">
          <app-request-date-control
            class="col-sm-12 col-lg-6 col-md-12"
            label="to"
            placeholder="To"
            formControlName="to"
            [minDate]="state.toMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!_responsive.isMobile()">
      <div class="select-date" *ngIf="state.ismonthOrDate == 'DATE'">
        <div class="from-set">
          <app-request-date-control
            class="col-sm-12 col-lg-12 col-md-12"
            label="From"
            placeholder="From"
            formControlName="from"
            [minDate]="state.fromMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
        <div class="to-set">
          <app-request-date-control
            class="col-sm-12 col-lg-12 col-md-12"
            label="To"
            placeholder="To"
            formControlName="to"
            [minDate]="state.toMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
      </div>
    </ng-container>
    <app-loan-DisDownformatlist
      class="col-sm-12 col-lg-12 col-md-12"
      label="Display / Download format"
      placeholder="Display / Download format"
      formControlName="displayDownloadFormat"
    ></app-loan-DisDownformatlist>
  </box>

  <ng-container *ngIf="_responsive.isMobile()">
    <div class="filter-form-btn">
      <box class="filter-form-btn-grp2">
        <button
          *ngIf="formGroup"
          type="button"
          (click)="_helper.submitForm()"
          class="button-common button40 active"
          [disabled]="!formGroup.valid || state.isDateValid"
        >
          <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
        </button>
      </box>
      <box class="filter-form-btn-grp1">
        <button
          type="button"
          class="btn-link"
          [ngClass]="{
            'btn-visibility-hidden': !state.showReset
          }"
          (click)="loanTransactionFilterFormHelper.reset()"
        >
          <span class="reset-btn">Reset</span>
        </button>
      </box>
    </div>
  </ng-container>
</form>
<ng-container *ngIf="!_responsive.isMobile()">
  <div class="filter-form-btn">
    <box class="filter-form-btn-grp2">
      <button
        type="button"
        class="btn-link"
        [ngClass]="{
          'btn-visibility-hidden': !state.showReset
        }"
        (click)="loanTransactionFilterFormHelper.reset()"
      >
        <span class="reset-btn">Reset</span>
      </button>
      <button
        *ngIf="formGroup"
        type="button"
        (click)="_helper.submitForm()"
        class="button-common button40 active"
        [disabled]="!formGroup.valid || state.isDateValid"
      >
        <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
      </button>
    </box>
  </div>
</ng-container>
